<template>
  <RequestProposalMVMGrid/>
</template>

<script>
import RequestProposalMVMGrid from './RequestProposalMVMGrid'
export default {
  components: {
    RequestProposalMVMGrid
  },
  data () {
    return {

    }
  },
  created () {
    this.$store.commit('updateTitle', 'Consultas y movimientos en OCs')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/MovimientosOC.vue